module.exports = __webpack_public_path__ + "static/media/password.d71ec1da.gif";